import React from 'react';

const Dropdown = ({
  label,
  name,
  value,
  onChange,
  options,
  required = false,
  error = '',
  className = '',
}) => {
  return (
    <div className={className}>
      <label className="block text-sm font-bold text-gray-700">
        {label} {required && <span className="text-danger">*</span>}
      </label>
      <select
        name={name}
        value={value}
        onChange={onChange}
        className="block w-full mt-1 p-3 text-sm  border border-gray-300 rounded-md shadow-sm"
        required={required}
      >
        <option className="font-sans font-bold" value="">Select {label}</option>
        {options.map((option) => (
          <option className="font-sans font-bold" key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {error && <p className="text-red-500 text-sm">{error}</p>}
    </div>
  );
};

export default Dropdown;
